import { render, staticRenderFns } from "./AlterationReferences.vue?vue&type=template&id=2b994dbb&scoped=true&"
import script from "./AlterationReferences.vue?vue&type=script&lang=js&"
export * from "./AlterationReferences.vue?vue&type=script&lang=js&"
import style0 from "./AlterationReferences.vue?vue&type=style&index=0&id=2b994dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b994dbb",
  null
  
)

export default component.exports